'use client';

import { useEffect } from 'react';

import { BlogPostFieldsFragment } from '@/gql/__generated/graphql.types';

export const blogSessionStorageAuthorKey = 'blogSessionStorageAuthorKey';
export const blogSessionStorageCategoryKey = 'blogSessionStorageCategoryKey';

type Props = {
  blog: BlogPostFieldsFragment;
};

const BlogPageDataLayerSessionStorage = ({ blog }: Props) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      blog.author?.name &&
        window.sessionStorage.setItem(blogSessionStorageAuthorKey, blog.author.name);
      blog.category?.length &&
        window.sessionStorage.setItem(blogSessionStorageCategoryKey, blog.category.join(','));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-time session storage write on mount
  }, []);

  return null;
};

export default BlogPageDataLayerSessionStorage;
